import React, { useCallback, useState } from "react";
import { PortalTherapist } from "../api/contracts";
import { CopingSkillsManager } from "../components/CopingSkillsManager";
import {
  ClinicianPortalLayout,
  PortalHeader,
} from "../components/PortalLayout";

export function CopingSkillsPage({ clinicianCode }: { clinicianCode: string }) {
  const [therapist, setTherapist] = useState<PortalTherapist>();
  const handleTherapistLoaded = useCallback(
    (loadedTherapist: PortalTherapist) => setTherapist(loadedTherapist),
    [],
  );

  return (
    <ClinicianPortalLayout
      activeGlobalKey="coping-skills"
      clinicianCode={clinicianCode}
      therapistRole={therapist?.role}
    >
      <PortalHeader
        title="Coping Skills"
        clinicianName={therapist?.therapistName}
      />
      <div className="cp-page-content cp-page-content--wide cp-page-content--sticky-card-list">
        <CopingSkillsManager
          clinicianCode={clinicianCode}
          scope={{ kind: "shared" }}
          onTherapistLoaded={handleTherapistLoaded}
        />
      </div>
    </ClinicianPortalLayout>
  );
}
